import { render } from "./TradeView.vue?vue&type=template&id=2b64cc62&scoped=true"
import script from "./TradeView.vue?vue&type=script&lang=js"
export * from "./TradeView.vue?vue&type=script&lang=js"

import "./TradeView.vue?vue&type=style&index=0&id=2b64cc62&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b64cc62"]])

export default __exports__